function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

jQuery(document).ready(function () {
  jQuery('#navtoggle').off('click');

  var $body = jQuery('body');
  var $wrapper = jQuery('#wrapper');
  var $document = jQuery(document);
  var $megamenu = jQuery('#megamenu');
  var $navigation = jQuery('#main-navigation');
  var lastPosition = window.scrollY;

  $document.on('click', '#mainnavigation .mainnavigation-sub > a', function (e) {
    e.preventDefault();

    // SYF-64
    //$(window).scrollTop(0);

    var $this = jQuery(this);

    if ($this.hasClass('active')) {
      window.location.href = $this.attr('href');
      return;
    }


    var target = $this.data('pid');
    var $megamenu = jQuery('#megamenu');
    var $target = $megamenu.find('[data-pid="' + target + '"]');
    var $nonTargets = $navigation.find('[data-pid][data-pid!="' + target + '"]');

    // Close copper api
    if($('.header-top-price ').hasClass('js-open')) {
      $('.header-top-price').trigger('click');
      setTimeout(function() {
        $navigation.addClass('navigation-white');
      },900);
    } else {
      $navigation.addClass('navigation-white');
    }
    $this.addClass('active');
    $nonTargets.removeClass('active');
    $target.addClass('active');
    $body.addClass('disallow-scroll');
    window.setTimeout(function () {
      $megamenu.addClass('active');
    }, 150);
  });

  $document.on('click', '.megamenu-close', function (e) {
    e.preventDefault();

    $body.removeClass('disallow-scroll');
    jQuery('#megamenu').removeClass('active');
    window.setTimeout(function () {
      if ($navigation.data('navigation-style') != 'white') {
        $navigation.removeClass('navigation-white');
      }
      jQuery('#megamenu [data-pid]').removeClass('active');
      jQuery('#mainnavigation .mainnavigation-li a').removeClass('active');
    }, 350);
  });

  $document.on('mouseover', '.megamenu-nav > ul > li', function (e) {
    e.preventDefault();
    var $this = jQuery(this);
    var target = $this.data('target');
    var $target = jQuery('.megamenu-content [data-target="' + target + '"]');
    var $targets = jQuery('.megamenu-content [data-target]');

    $targets.hide();
    $target.show();
  });

  $document.on('click', '#navtoggle', function (e) {
    e.preventDefault();

    var $this = jQuery(this);
    var $navigation = jQuery('.navigation-wrapper');

    $(window).scrollTop(0);

    if($this.hasClass('js-open')) {
      // Close all submenus
      console.log($navigation.find('.js-mainnavigation-open'));
      $navigation.find('.js-mainnavigation-open').removeClass('js-mainnavigation-open');
      $navigation.find('.mainnavigation-mobile').hide();
    }

    $this.toggleClass('js-open');
    $body.toggleClass('disallow-scroll');
    $body.toggleClass('mobile-navigation-open');
    $navigation.toggleClass('open');
  });

  var productPageUid = $megamenu.data('product-page');
  if (productPageUid) {
    var $item = jQuery('#mainnavigation .mainnavigation-li-' + productPageUid);
    $item.addClass('mainnavigation-sub');
  }

  // Kontakt öffnet Kontakt-Lasche
  $document.on('click', '#mainnavigation a[href="/kontakt/"], .body-service .ce-gallery .image a[href="/kontakt/"]', function (e) {
    e.preventDefault();
    $('aside.side-menu .contact').trigger('click');
  });

});
